import React, { Component } from 'react'
import Link from 'next/link'
import { Row, Col } from 'antd'
import CatalogNavBar from '../../catalog/catalog-nav-bar'
import SearchBox from '../../common/SearchBox'
import UserBar from '../user-bar'
import { connect } from 'react-redux'
import { clearSearchProduct } from '../../../actions'

const getColSpan = (showSearchBox, defaultSpan, productSpan) => {
  return showSearchBox ? productSpan : defaultSpan
}

class DesktopHeader extends Component {
  handleLogoClick = () => {
    this.props.clearSearchProduct()
  }

  render() {
    const { showSearchBox } = this.props

    return (
      <Row display='flex'>
        <Col xs={18} md={5} lg={4} xl={3}>
          <Link href='/'>
            <a className='logo' onClick={this.handleLogoClick}></a>
          </Link>
        </Col>

        <Col
          className='nav-bar-row'
          xs={{ span: 1 }}
          md={{ span: getColSpan(showSearchBox, 16, 7) }}
          lg={{ span: getColSpan(showSearchBox, 17, 10) }}
          xl={{ span: getColSpan(showSearchBox, 19, 14) }}
        >
          <CatalogNavBar />
        </Col>

        {showSearchBox && (
          <Col className='nav-bar-searchbox' xs={24} md={9} lg={7} xl={5}>
            <SearchBox catalogFilter submitOnKeys={[13]} autoFocus={true}></SearchBox>
          </Col>
        )}

        <Col
          className='nav-bar-buttons'
          xs={{ span: 4 }}
          md={{ span: 3 }}
          lg={{ span: 3 }}
          xl={{ span: getColSpan(showSearchBox, 2, 2) }}
        >
          <UserBar />
        </Col>
      </Row>
    )
  }
}

export default connect(null, {
  clearSearchProduct,
})(DesktopHeader)
